import { iconMixinPropsType } from "../../mixins/icon";
import { outerLayoutMixinPropsType, } from "../../mixins/outerLayout";
import { paddingMixinPropsType } from "../../mixins/padding";
import { textColorMixinPropsType, } from "../../mixins/textColor";
export const iconPropsType = paddingMixinPropsType
    .extend(outerLayoutMixinPropsType)
    .extend(textColorMixinPropsType)
    .extend(iconMixinPropsType)
    .complete({
    icon: true,
    className: true,
    disabled: true,
    fixedWidth: true,
    altText: true,
    action: true,
    spin: true,
    preventFill: true,
    _internal: true,
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHlwZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9JY29uL3R5cGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUlBLE9BQU8sRUFBa0Isa0JBQWtCLEVBQUUsTUFBTSxtQkFBbUIsQ0FBQztBQUN2RSxPQUFPLEVBRUwseUJBQXlCLEdBQzFCLE1BQU0sMEJBQTBCLENBQUM7QUFDbEMsT0FBTyxFQUFxQixxQkFBcUIsRUFBRSxNQUFNLHNCQUFzQixDQUFDO0FBQ2hGLE9BQU8sRUFFTCx1QkFBdUIsR0FDeEIsTUFBTSx3QkFBd0IsQ0FBQztBQW1DaEMsTUFBTSxDQUFDLE1BQU0sYUFBYSxHQUFHLHFCQUFxQjtLQUMvQyxNQUFNLENBQUMseUJBQXlCLENBQUM7S0FDakMsTUFBTSxDQUFDLHVCQUF1QixDQUFDO0tBQy9CLE1BQU0sQ0FBQyxrQkFBa0IsQ0FBQztLQUMxQixRQUFRLENBQVk7SUFDbkIsSUFBSSxFQUFFLElBQUk7SUFDVixTQUFTLEVBQUUsSUFBSTtJQUNmLFFBQVEsRUFBRSxJQUFJO0lBQ2QsVUFBVSxFQUFFLElBQUk7SUFDaEIsT0FBTyxFQUFFLElBQUk7SUFDYixNQUFNLEVBQUUsSUFBSTtJQUNaLElBQUksRUFBRSxJQUFJO0lBQ1YsV0FBVyxFQUFFLElBQUk7SUFDakIsU0FBUyxFQUFFLElBQUk7Q0FDaEIsQ0FBQyxDQUFDIn0=